var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Liga\\xE7\\xE3o de v\\xEDdeo",
    className: "x1lliihq x1n2onr6 x5n08af header-icon-img",
    fill: "currentColor",
    height: 24,
    role: "img",
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    fill: "#F9F9F9",
    id: titleId
  }, "Liga\xE7\xE3o de v\xEDdeo") : title ? /*#__PURE__*/React.createElement("title", {
    fill: "#F9F9F9",
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 18,
    rx: 3,
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    width: 16.999,
    x: 1,
    y: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.999 9.146 2.495-2.256A1.5 1.5 0 0 1 23 8.003v7.994a1.5 1.5 0 0 1-2.506 1.113L18 14.854",
    fill: "none",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.70cc2e42784798c5c6aef58438cda6e9.svg";
export { ForwardRef as ReactComponent };